"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAction = exports.parseArgs = void 0;
const bn_js_1 = require("bn.js");
const near_api_js_1 = require("near-api-js");
const getAccessKey = (permission) => {
    if (permission === "FullAccess") {
        return near_api_js_1.transactions.fullAccessKey();
    }
    const { receiverId, methodNames = [] } = permission;
    const allowance = permission.allowance ? new bn_js_1.BN(permission.allowance) : undefined;
    return near_api_js_1.transactions.functionCallAccessKey(receiverId, methodNames, allowance);
};
const parseArgs = (data) => {
    if (typeof data === "string")
        return Buffer.from(data, "base64");
    return data;
};
exports.parseArgs = parseArgs;
const createAction = (action) => {
    switch (action.type) {
        case "CreateAccount":
            return near_api_js_1.transactions.createAccount();
        case "DeployContract": {
            const { code } = action.params;
            return near_api_js_1.transactions.deployContract(code);
        }
        case "FunctionCall": {
            const { methodName, args, gas, deposit } = action.params;
            return near_api_js_1.transactions.functionCall(methodName, (0, exports.parseArgs)(args), new bn_js_1.BN(gas), new bn_js_1.BN(deposit));
        }
        case "Transfer": {
            const { deposit } = action.params;
            return near_api_js_1.transactions.transfer(new bn_js_1.BN(deposit));
        }
        case "Stake": {
            const { stake, publicKey } = action.params;
            return near_api_js_1.transactions.stake(new bn_js_1.BN(stake), near_api_js_1.utils.PublicKey.from(publicKey));
        }
        case "AddKey": {
            const { publicKey, accessKey } = action.params;
            return near_api_js_1.transactions.addKey(near_api_js_1.utils.PublicKey.from(publicKey), // TODO: Use accessKey.nonce? near-api-js seems to think 0 is fine?
            getAccessKey(accessKey.permission));
        }
        case "DeleteKey": {
            const { publicKey } = action.params;
            return near_api_js_1.transactions.deleteKey(near_api_js_1.utils.PublicKey.from(publicKey));
        }
        case "DeleteAccount": {
            const { beneficiaryId } = action.params;
            return near_api_js_1.transactions.deleteAccount(beneficiaryId);
        }
        default:
            throw new Error("Invalid action type");
    }
};
exports.createAction = createAction;
//# sourceMappingURL=index.js.map